import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ExtencionService } from 'src/app/services/extencion.service';

@Component({
  selector: 'app-modal-listado-extenciones',
  templateUrl: './modal-listado-extenciones.component.html',
  styleUrls: ['./modal-listado-extenciones.component.scss']
})
export class ModalListadoExtencionesComponent implements OnInit {
  public nombreUsuario: string = '';
  public dataSource: any;
  public displayedColumns: string[];
  public isLoadingResults = false;
  pageIndex: number = 0;
  pageSize: number = 10;
  length: number;
  searchString: string = '';
  public dataInput: any;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    public extencionSvc: ExtencionService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ModalListadoExtencionesComponent>
  ) {
    this.dataInput = data;
    console.log('los datos de ingreso son: ', data);

    let ELEMENT_DATA: any[] = [];
    this.displayedColumns = ['nombre', 'usuarioCreador','fechaAnterior', 'fechaNueva','comentario'];

    this.dataSource = new MatTableDataSource<any>(ELEMENT_DATA);
  }

  ngOnInit(): void {
    // this.inicarFormulario();

    this.nombreUsuario = this.dataInput.nombre;
    this.getListadoExtenciones(0, 10);
  }

  getListadoExtenciones(page: number, numReg: number) {
    this.extencionSvc
      .getExtencionesServicios({page, numReg, usuarioId:this.dataInput.id})
      .subscribe((result) => {
        console.log(result);

        this.dataSource = new MatTableDataSource<any>(result[0]);
        this.pageIndex = page;
        this.pageSize = numReg;
        this.length = result[1];
        this.isLoadingResults = false;
      });
  }

  getServerData(event: PageEvent) {
    console.log('click evento paginator', event);
    this.getListadoExtenciones(event.pageIndex, event.pageSize);
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

}
